export const CancelRefreshTokenExpired = 'canceled.refreshToken.expired'
export const UnknownErrorMessage = 'common.error.unknown'
